import { stripNamespacePrefix } from "./nameUtils";

const DEFAULT_CONSTRAINT_PREFIX = "constraint";

export const stripConstraintNamePrefix = (name) => {
  return stripNamespacePrefix(name);
};

/**
 * True for MJCF/internal names emitted on export (eq_<uuid>), legacy bad names (b_, b_-1),
 * or empty — these should not be shown as the user-facing label.
 */
export function isAutoGeneratedConstraintXmlName(name) {
  const base = stripConstraintNamePrefix(name)?.trim();
  if (!base) return true;
  if (/^b_(?:-\d+)?$/i.test(base)) return true;
  // eq_<uuid_underscores> with optional -N disambiguation suffix from reserveUniqueName
  if (/^eq_[0-9a-f]{8}_[0-9a-f]{4}_[0-9a-f]{4}_[0-9a-f]{4}_[0-9a-f]{12}(?:-\d+)?$/i.test(base))
    return true;
  return false;
}

const equalityEntries = (equalities) => Object.values(equalities || {}).filter((eq) => eq?.uuid);

export function getConstraintDisplayName(
  equalityOrUuid,
  equalities,
  prefix = DEFAULT_CONSTRAINT_PREFIX
) {
  const uuid = typeof equalityOrUuid === "string" ? equalityOrUuid : equalityOrUuid?.uuid;
  const equality =
    typeof equalityOrUuid === "string" ? equalities?.[equalityOrUuid] : equalityOrUuid;

  const stripped = stripConstraintNamePrefix(equality?.name)?.trim();
  const explicit = stripped && !isAutoGeneratedConstraintXmlName(equality?.name) ? stripped : "";
  if (explicit) return explicit;

  const index = equalityEntries(equalities).findIndex((eq) => String(eq.uuid) === String(uuid));
  return `${prefix} ${index >= 0 ? index + 1 : 1}`;
}

export function nextConstraintName(equalities, prefix = DEFAULT_CONSTRAINT_PREFIX) {
  const used = new Set();
  equalityEntries(equalities).forEach((eq, index) => {
    const stripped = stripConstraintNamePrefix(eq.name)?.trim();
    const label =
      stripped && !isAutoGeneratedConstraintXmlName(eq.name) ? stripped : `${prefix} ${index + 1}`;
    used.add(label);
  });

  let index = 1;
  while (used.has(`${prefix} ${index}`)) index += 1;
  return `${prefix} ${index}`;
}
